import { render, staticRenderFns } from "./ActivoFijoComponent.vue?vue&type=template&id=2ba12e73&"
import script from "./ActivoFijoComponent.vue?vue&type=script&lang=js&"
export * from "./ActivoFijoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ActivoFijoComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports